import React, {useState, useEffect} from 'react';
import {Helmet} from "react-helmet";

import Launcher from '../components/Launcher'
import ConfigErrorPage from './pages/configurationError'
import MaintenancePage from './pages/maintenance'
import UserContext from '../_context/user.context'
import ConfigContext from '../_context/config.context'
import settings,{ settingsLoaded }  from '../config/settings'
import defaultSettings from '../config.sample/settings'
import { connect } from 'react-redux'

import './App.css';

function App({
  user,
  dispatch,
  chatbotReferral,
  chatOpenByDefault,
  autoRestartSession,
  enableFeedback,
  hideRestartOnFeedback,
  enableFileUpload,
  showWatermark,
  useCustomLauncher,
  customLauncherHeight,
  customLauncherWidth,
  persistenMenuButton,
  headerShowName,
  headerBadgeStyle
}) {
  const [config, setConfig] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Wait for settings.js to finish fetching from the backend
    settingsLoaded.then((syncedSettings) => {
      const finalConfig = {
        ...syncedSettings,
        ...chatbotReferral && { CHATBOT_REFERRAL: chatbotReferral },
        ...chatOpenByDefault && { CHAT_OPEN_BY_DEFAULT: chatOpenByDefault === 'true' },
        ...autoRestartSession && { AUTO_RESTART_SESSION: autoRestartSession === 'true' },
        ...enableFeedback && { ENABLE_FEEDBACK: enableFeedback === 'true' },
        ...hideRestartOnFeedback && { HIDE_RESTART_ALERT_ON_FEEDBACK_PAGE: hideRestartOnFeedback === 'true' },
        ...enableFileUpload && { ENABLE_FILE_UPLOAD: enableFileUpload === 'true' },
        ...showWatermark && { SHOW_WATERMARK: showWatermark === 'true' },
        ...useCustomLauncher && { USE_CUSTOM_LAUNCHER: useCustomLauncher === 'true' },
        ...customLauncherHeight && { CUSTOM_LAUNCHER_HEIGHT: parseInt(customLauncherHeight) },
        ...customLauncherWidth && { CUSTOM_LAUNCHER_WIDTH: parseInt(customLauncherWidth) },
        ...persistenMenuButton && { PERSISTENT_MENU_BUTTON: persistenMenuButton === 'true' },
        ...headerShowName && { HEADER_SHOW_NAME: headerShowName === 'true' },
        ...headerBadgeStyle && { HEADER_BADGE_STYLE: headerBadgeStyle },
      };

      setConfig(finalConfig);
      setIsReady(true);
    });
  }, [
    chatbotReferral, chatOpenByDefault, autoRestartSession, enableFeedback,
    hideRestartOnFeedback, enableFileUpload, showWatermark, useCustomLauncher,
    customLauncherHeight, customLauncherWidth, persistenMenuButton, headerShowName, headerBadgeStyle
  ]);

  // Restoring modifyConfig function
  const modifyConfig = (newConfig) => {
    if (!newConfig) {
      // If null is passed, reset to the original synced settings
      setConfig(settings);
    } else {
      setConfig((prevConfig) => ({
        ...prevConfig,
        ...newConfig
      }));
    }
  };

  // Loading Guard
  if (!isReady) return null;

  const requiredKeys = Object.keys(defaultSettings);
  const currentKeys = Object.keys(config);
  const missingKeys = requiredKeys.filter(x => !currentKeys.includes(x));

  if (missingKeys.length > 0) {
    return <ConfigErrorPage config={config} missingKeys={missingKeys} />;
  } else if (config.maintenance && config.maintenance.active) {
    return <MaintenancePage config={config} />;
  }

  return (
    <UserContext.Provider value={{ user, dispatch }}>
      {/* modifyConfig is now correctly passed into the Provider */}
      <ConfigContext.Provider value={{ config, modifyConfig }}>
        {config.WIDE_MODE && (
          <Helmet>
            <meta name="description" content={config.BOT_NAME} />
            <title>{config.BOT_NAME}</title>
          </Helmet>
        )}
        <div className="App" style={{ fontFamily: config.FONT_FAMILY }}>
          <Launcher />
        </div>
      </ConfigContext.Provider>
    </UserContext.Provider>
  );
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(App)
